var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.atual.texto)?_c('div',[_c('div',{staticClass:"container editor mt-12",domProps:{"innerHTML":_vm._s(_vm.atual.texto)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }